import type { NavigateTarget } from '@s2w/core';

const SOURCE = 'low6-s2w' as const;

export interface CaesarsPostMessageEnvelope {
  readonly source: typeof SOURCE;
  readonly type: string;
  readonly payload?: Record<string, unknown>;
}

export function buildAddToSlipMessage(selectionIds: readonly string[]): CaesarsPostMessageEnvelope {
  if (selectionIds.length === 0) {
    throw new Error('Cannot build AddToSlip with zero selections');
  }
  return {
    source: SOURCE,
    type: 'AddToSlip',
    payload: { selectionIds: [...selectionIds] },
  };
}

/**
 * The payload keys are snake_case to match the shape Caesars' other games
 * already send, which their navigation reads.
 */
export function buildNavigateMessage(target: NavigateTarget): CaesarsPostMessageEnvelope {
  return {
    source: SOURCE,
    type: 'Navigate',
    payload: {
      sport: target.sport,
      competition_name: target.competitionName,
      competition_id: target.competitionId,
    },
  };
}

export function buildCloseGameMessage(): CaesarsPostMessageEnvelope {
  return {
    source: SOURCE,
    type: 'CloseGame',
  };
}
